import React, { Component } from "react";
import { Modal, ButtonToolbar, Button, Table, Grid, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import { PropTypes } from "prop-types";

import { TitleRow } from '../../TitleRow';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { HandleMessage } from '../../HandleMessage';
import { StopsCommand } from '../commands/StopsCommand';
import { DrawCommand } from '../commands/DrawCommand';
import { OptionsFormatHelper } from '../helpers/OptionsFormatHelper';

class QrCodeOptions extends Component {
    render() {
        const { show, options } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>OPÇÕES PARA CONTEÚDO DO QR CODE</Modal.Header>
                <Modal.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Opção</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map((option, idx) =>
                                    <tr className="selectable" key={`data-${idx}`}>
                                        <td onClick={() => this.props.onSelect(OptionsFormatHelper.getOptionValue(option))}>
                                            {OptionsFormatHelper.getOptionText(option)}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <ButtonToolbar>
                        <Button onClick={this.props.onHide}>CANCELAR</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}

export class SpiderMap extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                stops: new StopsCommand(),
                draw: new DrawCommand()
            },
            dependencies: {
                stops: {
                    data: [],
                    sortColumn: "name",
                    sortOrder: "ascending"
                }
            },
            form: {
                stops: [],
                date: new Date().toISOString(),
                qrCode: undefined
            },
            qrCodeOptions: {
                show: false,
                options: [
                    "stopCode",
                ]
            },
            actions: {
                isLoadingStops: true,
                isGenerating: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
        };
    }

    componentDidMount() {
        this.context.selectApp("spidermap", false);

        this.getStops();
    }

    // ----------------------

    getStops() {
        const { dependencies, actions } = this.state;

        dependencies.stops.data = [];
        actions.isLoadingStops = true;

        this.setState({
            dependencies: dependencies,
            actions: actions
        });

        const { commands } = this.state;
        commands.stops.getAll(
            (a) => this.listDependencySuccessCallback(a, "isLoadingStops", "stops"),
            (a) => this.listDependencyErrorCallback(a, "isLoadingStops", "stops")
        );
    }

    // ----------------------

    listDependencySuccessCallback(result, action, dependency) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dependency].data = result;

        if (undefined !== dependencies[dependency].sortColumn) {
            try {
                dependencies[dependency].data = dependencies[dependency].data.sort((a, b) =>
                    this.sort(a, b, dependencies[dependency].sortColumn, dependencies[dependency].sortOrder)
                );
            } catch (_) { }
        }

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listDependencyErrorCallback(messageReceived, action, dependency) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dependency].data = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        // Update data
        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    sort(first, second, sortColumn, sortOrder) {
        var a = (first)[sortColumn];
        var b = (second)[sortColumn];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sortOrder === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sortOrder === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sortOrder === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    sortDependency(dependency, column) {
        const { dependencies } = this.state;

        if (column === dependencies[dependency].sortColumn) {
            dependencies[dependency].sortOrder = "ascending" === dependencies[dependency].sortOrder ? "descending" : "ascending";
        }
        else {
            dependencies[dependency].sortColumn = column;
            dependencies[dependency].sortOrder = "ascending";
        }

        dependencies[dependency].data = dependencies[dependency].data.sort((a, b) =>
            this.sort(a, b, dependencies[dependency].sortColumn, dependencies[dependency].sortOrder)
        );

        this.setState({
            dependencies: dependencies
        });
    }

    // ----------------------

    handleGenerateClick() {
        const { form } = this.state;
        let message = "";

        if (null === form.date || undefined === form.date || "" === form.date) {
            message = `${message}Tem de selecionar uma data\n`;
        }

        if (0 === form.stops.length) {
            message = `${message}Tem de selecionar pelo menos 1 Paragem\n`;
        }

        if ("" === message) {
            const { commands, actions } = this.state;

            actions.isGenerating = true;

            commands.draw.generate(
                form,
                (a) => this.generationSuccessCallback(a),
                (a) => this.generationErrorCallback(a))

            this.setState({
                actions: actions
            });
        }
        else {
            this.setState({
                message: {
                    show: true,
                    message: message,
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
    }

    selectAllStopsHandler() {
        const { form, dependencies } = this.state;

        form.stops = dependencies.stops.data.map(stop => stop.id);

        this.setState({
            form: form
        });
    }

    onRowClick(entity, property) {
        const { form } = this.state;

        if (form[property].includes(entity.id)) {
            form[property] = form[property].filter(prop => prop !== entity.id);
        }
        else {
            form[property].push(entity.id)
        }

        this.setState({
            form: form
        });
    }

    handleOptionsClick() {
        const { qrCodeOptions } = this.state;

        qrCodeOptions.show = true;

        this.setState({
            qrCodeOptions: qrCodeOptions
        });
    }

    // ----------------------

    onChangeDate(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onSelectQrCodeOption(value) {
        const { form } = this.state;

        if(undefined === form.qrCode || null === form.qrCode) {
            form.qrCode = value;
        }
        else {
            form.qrCode += value;
        }

        this.setState({
            form: form
        }, () => {
            const textInput = document.getElementById("qrCodeInput");

            textInput.focus();
            textInput.setSelectionRange(form.qrCode.length, form.qrCode.length);
        });

        this.onExitQrCodeOptions();
    }

    // ----------------------

    onExitQrCodeOptions() {
        const { qrCodeOptions } = this.state;

        qrCodeOptions.show = false;

        this.setState({
            qrCodeOptions: qrCodeOptions
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    renderSortIndicator(data, compareValue) {
        if (compareValue === data.sortColumn) {
            return <SortIndicator order={data.sortOrder} />;
        }

        return <SortIndicator order="none" />;
    }

    renderForm() {
        const { form } = this.state;

        return (
            <Grid fluid className="margin-top-15">
                <Row>
                    <Col sm={12}>
                        <DatePicker
                            id="referenceDateDatePicker"
                            dateFormat="DD/MM/YYYY"
                            value={form.date}
                            placeholder="Introduza a Data de Referência"
                            onChange={(e) => this.onChangeDate(e, "date")} />
                    </Col>
                </Row>
                <Row className="margin-top-10">
                    <Col sm={12}>
                        <InputGroup bsSize="small">
                            <FormControl
                                id="qrCodeInput"
                                type="text"
                                placeholder="QR Code Url"
                                value={form.qrCode}
                                onChange={(e) => this.onChangeValue(e, "qrCode")} />

                            <InputGroup.Button>
                                <Button onClick={() => this.handleOptionsClick()}>OPÇÕES</Button>
                            </InputGroup.Button>
                        </InputGroup>
                    </Col>
                </Row>
            </Grid >
        );
    }

    renderStops(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        const { dependencies, form } = this.state;

        return (

            <Grid fluid className="margin-top-15">
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th className="width-20p" onClick={() => this.sortDependency("stops", "code")}>Código {this.renderSortIndicator(dependencies.stops, "code")}</th>
                                    <th className="width-80p" onClick={() => this.sortDependency("stops", "name")}>Nome {this.renderSortIndicator(dependencies.stops, "name")}</th>
                                    <th><Button bsSize="small" className="pull-right" onClick={() => this.selectAllStopsHandler()}>SELECIONAR TUDO</Button></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dependencies.stops.data.map((stop, idx) =>
                                        <tr key={`stop-${idx}`} className={`spidermap selectable ${form.stops.includes(stop.id) ? "checked" : ""}`} onClick={() => this.onRowClick(stop, "stops")}>
                                            <td>{stop.code}</td>
                                            <td colSpan={2}>{stop.name}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, qrCodeOptions, message } = this.state;

        return (
            <div>
                <TitleRow title="Spider Map" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.handleGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderForm()}
                {this.renderStops(actions.isLoadingStops)}

                <QrCodeOptions
                    options={qrCodeOptions.options}
                    show={qrCodeOptions.show}
                    onHide={() => this.onExitQrCodeOptions()}
                    onSelect={(a) => this.onSelectQrCodeOption(a)} />

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title="A Gerar Spider Maps..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isGenerating}
                    small
                    noButtons />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/spidermap/SpiderMap.js